"use client";

import React from "react";
import { ArrowRight, ShoppingCart, Users, Globe, Award } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const statsData = [{
  id: "delivered",
  value: "$1,700",
  label: "AVG ANNUAL ATHLETE SPEND\xA0",
  iconName: "cart"
}, {
  id: "clients",
  value: "4.0% CTR",
  label: "EARLY ESMG CAMPAIGN\xA0 TEST",
  iconName: "users"
}, {
  id: "countries",
  value: "66%",
  label: "REGISTER EARLY 30-120 DAYS\xA0",
  iconName: "globe"
}, {
  id: "satisfaction",
  value: "31-120",
  label: "DAY PURCHASING\xA0 WINDOW",
  iconName: "award"
}];
export default function About() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257115" id="high-value-audience" className="py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          <div ref={leftRef} className={cn("flex flex-col items-start transition-all duration-1000 ease-out", isLeftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12")}><span className="text-primary font-default font-semibold tracking-widest uppercase text-sm md:text-base mb-3" data-ast-id="f:/src/pages/Home/sections/About.tsx|sig:uf4pa8" data-ast-start="1501" data-ast-end="1658">The Audience</span><h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold mb-6 leading-tight text-foreground" data-ast-id="f:/src/pages/Home/sections/About.tsx|sig:l35p82" data-ast-start="1671" data-ast-end="1854">Reach Endurance Athletes Throughout Their Journey</h2><p className="text-muted-foreground text-lg mb-4 leading-relaxed font-default" data-ast-id="f:/src/pages/Home/sections/About.tsx|sig:kwk782" data-ast-start="1867" data-ast-end="2228">Endurance athletes consistently research, train, compete and prepare for their next challenge. That journey creates valuable advertising opportunities across footwear, apparel, wearables, nutrition, recovery, travel and training services.</p><p className="text-muted-foreground text-lg mb-4 leading-relaxed font-default" data-ast-id="f:/src/pages/Home/sections/About.tsx|sig:kwk783" data-ast-start="2241" data-ast-end="2935" contenteditable="false" style={{}}>From researching a first half marathon to preparing for a destination triathlon, athletes generate intent signals throughout their journey. ESMG helps advertisers identify relevant audiences through race discovery, registration-related actions, training research, community discussions, live tracking and results engagement.<br /><br />Reach endurance audiences based on what they're actively exploring—not simply whether an advertising platform classifies them as interested in sports.</p><a rel="noopener noreferrer" className="text-muted-foreground mb-8 leading-relaxed font-default block transition-colors !font-normal !text-lg hover:text-primary" data-ast-id="f:/src/pages/Home/sections/About.tsx|sig:cov7zv" data-ast-start="2948" data-ast-end="3231" href="https://findarace.com/directors-blog/trends-report-2025" target="_blank">Trend report: https://findarace.com/directors-blog/trends-report-2025</a></div>

          <div ref={rightRef} className={cn("bg-card rounded-lg p-8 sm:p-12 shadow-xl border border-border transition-all duration-1000 ease-out delay-200", isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12")}>
            <div className="grid grid-cols-1 sm:grid-cols-2">
              {statsData.map((stat, i) => {
              let Icon = ShoppingCart;
              if (stat.iconName === "users") Icon = Users;
              if (stat.iconName === "globe") Icon = Globe;
              if (stat.iconName === "award") Icon = Award;
              return <div key={stat.id} data-index={i} className={cn("flex flex-col items-center text-center", i === 0 && "border-b sm:border-r border-border pb-8 sm:pb-10 sm:pr-8", i === 1 && "border-b border-border pb-8 sm:pb-10 pt-8 sm:pt-0 sm:pl-8", i === 2 && "sm:border-r border-border pt-8 sm:pt-10 pb-8 sm:pb-0 sm:pr-8", i === 3 && "pt-8 sm:pt-10 sm:pl-8")}>
                    <Icon className="size-10 text-primary mb-5" strokeWidth={1.5} />
                    <h3 className="text-4xl font-default font-bold text-foreground mb-2 tracking-tight">
                      {stat.value}
                    </h3>
                    <p className="text-sm text-muted-foreground font-default font-medium uppercase tracking-wider">
                      {stat.label}
                    </p>
                  </div>;
            })}
            </div>
          </div>

        </div>
      </div>
    </section>;
}